import { type ReactNode, useCallback, useState } from "react";
import { Locales } from "@/app/lang/types";
import { defaultLang } from "@/app/lang/utils";
import { LOCAL_STORAGE_KEYS } from "@/app/localStorage/model";
import { ReactContext } from "@/app/providers/ReactContextProvider/react-context";
import { ErrorMessageType } from "@/app/providers/ReactContextProvider/types";

export function ReactContextProvider({ children }: { children: ReactNode }) {
  const [loading, setLoading] = useState(false);
  const [lang, setLang] = useState<Locales>(defaultLang);
  const [errorMessage, setErrorMessage] = useState<ErrorMessageType>(null);

  const setLangMemoized = useCallback(() => {
    setLang((prev) => {
      const nextValue = prev === Locales.Ru ? Locales.Kz : Locales.Ru;
      localStorage.setItem(LOCAL_STORAGE_KEYS.LANG, nextValue);
      return nextValue;
    });
  }, []);

  return (
    <ReactContext
      value={{
        loading,
        setLoading,
        lang,
        setLang: setLangMemoized,
        errorMessage,
        setErrorMessage,
      }}
    >
      {children}
    </ReactContext>
  );
}
